var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06135 12.7873L0 6.72597L1.51534 5.21063L6.06135 9.75665L15.818 0L17.3333 1.51534L6.06135 12.7873Z",
    fill: "#03A56B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCheck);
export default __webpack_public_path__ + "static/media/filterCheck.5ef402c49cb79e9ccb721a10159c519b.svg";
export { ForwardRef as ReactComponent };